import { forwardRef, useImperativeHandle, useState } from "react"
import { Mask } from 'antd-mobile'
import { useTranslation } from "react-i18next"
import CommonUtil from "../../utils/CommonUtil"

const WechatDialog = (props, ref) => {
    const { t } = useTranslation()
    const [wechatDlgVisible, setWechatDlgVisible] = useState(false)

    useImperativeHandle(ref, () => ({
        show: () => {
            setWechatDlgVisible(true)
        },
        dismiss: () => {
            setWechatDlgVisible(false)
        }
    }))

    return <>
        <Mask visible={wechatDlgVisible} onMaskClick={() => setWechatDlgVisible(false)}
            color='#00000066'>
            <div className='wechatContent'>
                <img src={`${CommonUtil.getSourceDomain()}wechat_qr_image.png`} alt="" style={{ width: 130, height: 130 }} />
                <div style={{ fontSize: 14, color: '#373150', marginTop: 5 }}>{t('wechat') + ': ' + t('wechat_account')}</div>
                <div style={{ height: 1, width: '100%', background: '#E5E5E5', marginTop: 28 }} />
                <div style={{ fontSize: 16, color: '#7F56FF', fontWeight: '500', marginTop: 15 }}
                    onClick={() => setWechatDlgVisible(false)}>{t('btn_sure')}</div>
            </div>
        </Mask>
    </>
}

export default forwardRef(WechatDialog)